import { Injectable } from '@angular/core';
import { StageService } from './stage.service';
import { ConstantsService } from './constants.service';
import { SizeHelperService } from './size-helper.service';
import { SetMaterialsService } from './set-materials.service';
import { ModelLoaderService } from './model-loader.service';
declare var THREE: any;

@Injectable()
export class BuildTierStepsService {

  constructor(
    private stage: StageService,
    private constants: ConstantsService,
    private sizeHelper: SizeHelperService,
    private materialSrvc: SetMaterialsService,
    private modelLoaderService: ModelLoaderService
  ) { }

  async build1StepUp(config: any): Promise<any> {
    let tier = this.stage.getFloorById(config.floorId);
    const res = await this.modelLoaderService.loadLocalModel('Intermediate_step');
    let stair = new THREE.Object3D();
    stair.name = 'tierSteps';
    this.stage.add(stair);

    config.model = res;
    let stairStep = this.getStep(config, -37.32, 14);
    this.stage.add(stairStep);
    THREE.SceneUtils.attach(stairStep, this.stage.getScene(), stair);

    let scale = config.width / this.constants.inermediateStepSize.width;
    stair.children.forEach(obj => {
      obj.scale.set(scale, 1, 1);
    });

    THREE.SceneUtils.attach(stair, this.stage.getScene(), tier);

    stair.userData.config = config;

    await this.materialSrvc.setMaterialToTierSteps();
  }

  async build2StepsUp(config: any): Promise<any> {
    let tier = this.stage.getFloorById(config.floorId);
    const res = await this.modelLoaderService.loadLocalModel('Intermediate_step');
    let stair = new THREE.Object3D();
    stair.name = 'tierSteps';
    this.stage.add(stair);

    config.model = res;
    let bottomStairStep = this.getStep(config, -20.5 - 14 - 20.32, 14 + this.sizeHelper.INCHToCM(9)),
      topStairStep = this.getStep(config, -20.5 - 14 - 20.32 + 18, 14);

    this.stage.add(bottomStairStep);
    this.stage.add(topStairStep);
    THREE.SceneUtils.attach(bottomStairStep, this.stage.getScene(), stair);
    THREE.SceneUtils.attach(topStairStep, this.stage.getScene(), stair);
    stair.updateMatrixWorld(true);

    let scale = config.width / this.constants.inermediateStepSize.width;
    stair.children.forEach(obj => {
      obj.scale.set(scale, 1, 1);
    });

    THREE.SceneUtils.attach(stair, this.stage.getScene(), tier);

    stair.userData.config = config;

    await this.materialSrvc.setMaterialToTierSteps();
  }

  async build1StepDown(config: any): Promise<any> {
    let tier = this.stage.getFloorById(config.floorId);
    const res = await this.modelLoaderService.loadLocalModel('Intermediate_step');
    let stair = new THREE.Object3D();
    stair.name = 'tierSteps';
    this.stage.add(stair);

    config.model = res;
    let stairStep = this.getStep(config, -37 + 17 + 20.32, 9, true);

    this.stage.add(stairStep);
    THREE.SceneUtils.attach(stairStep, this.stage.getScene(), stair);

    let scale = config.width / this.constants.inermediateStepSize.width;
    stair.children.forEach(obj => {
      obj.scale.set(scale, 1, 1);
    });

    THREE.SceneUtils.attach(stair, this.stage.getScene(), tier);
    
    stair.userData.config = config;

    await this.materialSrvc.setMaterialToTierSteps();
  }

  async build2StepsDown(config: any): Promise<any> {
    let tier = this.stage.getFloorById(config.floorId);
    const res = await this.modelLoaderService.loadLocalModel('Intermediate_step');
    let stair = new THREE.Object3D();
    stair.name = 'tierSteps';
    this.stage.add(stair);

    config.model = res;
    let bottomStairStep = this.getStep(config, -55 + 55, 9, true),
      topStairStep = this.getStep(config, -37 + 55, 9 + this.sizeHelper.INCHToCM(9), true);

    this.stage.add(topStairStep);
    this.stage.add(bottomStairStep);
    THREE.SceneUtils.attach(topStairStep, this.stage.getScene(), stair);
    THREE.SceneUtils.attach(bottomStairStep, this.stage.getScene(), stair);

    let scale = config.width / this.constants.inermediateStepSize.width;
    stair.children.forEach(obj => {
      obj.scale.set(scale, 1, 1);
    });

    THREE.SceneUtils.attach(stair, this.stage.getScene(), tier);
    
    stair.userData.config = config;

    await this.materialSrvc.setMaterialToTierSteps();
  }

  private getStep(config: any, heightOffset: number, offsetFromDeck: number, isDownStep?: boolean): any {

    let stairStep = config.model.clone();
    stairStep.children.forEach(ch => {
      ch.receiveShadow = true;
      ch.castShadow = ch.name !== 'Fascia';
    });
    stairStep.isDeckComponent = true;
    stairStep.isChildStep = true;
    let A = new THREE.Vector3(config.firstPoint.x, 0, config.firstPoint.y);
    let B = new THREE.Vector3(config.secondPoint.x, 0, config.secondPoint.y);
    let AB = new THREE.Vector3(B.x - A.x, 0, B.z - A.z);

    let AB2 = AB.clone();
    AB2.normalize();

    let vect = new THREE.Vector3(AB.z, 0, -AB.x);
    let norm = vect.clone().normalize();
    var norm1 = new THREE.Vector3(0, 0, 1);
    let angle = norm1.angleTo(vect);
    norm.setLength(offsetFromDeck);

    let currentFloor = this.stage.getFloorById(config.floorId);
    let parentTier = this.stage.getCompoundFloor().children.find(tier => tier.userData.customId === config.parentCustomId);
    let parentFirstPointIndex = parentTier.userData.points.findIndex(point => point.childCustomId === currentFloor.userData.customId);
    let parentFirstPoint = parentTier.userData.points[parentFirstPointIndex];
    let parentSecondPointIndex = parentFirstPointIndex + 1 === parentTier.userData.points.length ? 0 : parentFirstPointIndex + 1;
    let parentSecondPoint = parentTier.userData.points[parentSecondPointIndex];

    let C = new THREE.Vector3(parentFirstPoint.x, 0, parentFirstPoint.y);
    let D = new THREE.Vector3(parentSecondPoint.x, 0, parentSecondPoint.y);
    let CD = new THREE.Vector3(D.x - C.x, 0, D.z - C.z);
    let DB = new THREE.Vector3(B.x - D.x, 0, B.z - D.z);
    let DC = new THREE.Vector3(C.x - D.x, 0, C.z - D.z);
    let CA = new THREE.Vector3(A.x - C.x, 0, A.z - C.z);
    let DA = new THREE.Vector3(A.x - D.x, 0, A.z - D.z);

    let projectionLength = (DB.x * DC.x + DB.z * DC.z) / CD.length();
    let projectionLength2 = (CD.x * CA.x + CD.z * CA.z) / CD.length();
    let minLength = Math.min(projectionLength, projectionLength2, AB.length(), CD.length());

    // найти самую левую из двух правых точек и отступать от нее дистанс (юзать ее как позишн)
    let projectParentSPOnThisFP = (DA.x * DC.x + DA.z * DC.z) / CD.length();
    let positionPoint = config.firstPoint;
    if (projectParentSPOnThisFP < 0) {
      positionPoint = parentSecondPoint;
    }

    const rebuildData = this.getDistWidth(positionPoint, config.secondPoint, parentFirstPoint, config.width, config.distance);
    
    if(rebuildData.needStepRebuild){
      config.distance = rebuildData.distance;
      config.width = rebuildData.width;
    }


    // so steps don't built outside edge
    if (minLength - config.distance < config.width / 2) {
      config.distance = minLength - config.width / 2;
    }
    if (config.distance < config.width / 2) {
      config.distance = config.width / 2;
    }
    if (minLength < config.width) {
      config.width = minLength;
      config.distance = config.width / 2;
    }
    config.firstPoint.width = config.width;
    config.firstPoint.distance = config.distance;

    AB2.setLength(config.distance);

    stairStep.position.set(positionPoint.x,
      config.height + heightOffset,
      positionPoint.y);

    if (projectParentSPOnThisFP < 0) {
      let offsetToParent = this.constants.tierTypeSettingsMap[config.superstructureType].distanceToTier;
      let norm2 = norm.clone();
      norm2.negate();
      norm2.setLength(offsetToParent);
      stairStep.position.add(norm2);
    }
    stairStep.position.add(norm);

    stairStep.position.add(AB2);

    stairStep.rotation.y = angle;

    for (let k = 0; k < 8; k++) {
      let dir = stairStep.getWorldDirection(new THREE.Vector3());
      if (isDownStep) dir.negate();
      if (!(norm.x > dir.x - 0.05 && norm.x < dir.x + 0.05 && norm.z > dir.z - 0.05 && norm.z < dir.z + 0.05)) {
        stairStep.rotation.y -= norm.angleTo(dir);
      }
    }

    return stairStep;
  }

  getDistWidth(positionPoint, secondPoint, parentFirstPoint, stepWidth, stepDistance){
    const pp = new THREE.Vector3(positionPoint.x, 0, positionPoint.y);
    const sp = new THREE.Vector3(secondPoint.x, 0, secondPoint.y);
    const parentFp = new THREE.Vector3(parentFirstPoint.x, 0, parentFirstPoint.y);
    let width = pp.distanceTo(sp) >= pp.distanceTo(parentFp)? pp.distanceTo(parentFp) : pp.distanceTo(sp) ;
    const distance = width/2;
    width -= this.constants.minimalSpaceForStairsOnSIde*2
    const distanceToFp = stepDistance - stepWidth / 2;
    const distanceToSp = width - (stepDistance + stepWidth / 2);
    let needStepRebuild: boolean = false;
    if(!this.constants.minimalSpaceForStairsOnSIde){
      needStepRebuild = (distanceToSp < 30 && distanceToSp >2) || (distanceToFp < 30 && distanceToFp > 2) ? true : false;
    } 
    else{
      needStepRebuild = distanceToSp < 30 || distanceToFp < 30  ? true : false;
    }
    return{
      distance: distance,
      width: width,
      needStepRebuild: needStepRebuild
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/build-tier-steps.service.ts